import axios from 'axios';

const API_BASE_URL = '/api/analytics';

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    console.log(`API Response: ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error(`API Error: ${error.response?.status} ${error.config?.url}`, error.response?.data);
    return Promise.reject(error);
  }
);

// Dashboard API functions
export const dashboardApi = {
  // Get dashboard statistics
  getStats: async () => {
    try {
      const response = await apiClient.get('/dashboard/stats/');
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      throw error;
    }
  },

  // Get market health summary
  getMarketHealth: async (market = null) => {
    try {
      const params = market ? { market } : {};
      const response = await apiClient.get('/market-health/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching market health:', error);
      throw error;
    }
  },

  // Get market data health check
  getMarketDataHealth: async () => {
    try {
      const response = await apiClient.get('/market-health/');
      return response.data;
    } catch (error) {
      console.error('Error fetching market data health:', error);
      throw error;
    }
  },

  // Get YouTube monthly stats with optional year filter
  getYouTubeMonthlyStats: async (year = null) => {
    try {
      const params = year ? { year } : {};
      const response = await apiClient.get('/youtube/monthly-stats/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching YouTube monthly stats:', error);
      throw error;
    }
  },

  // Get users count
  getUsersCount: async () => {
    try {
      const response = await apiClient.get('/users/');
      return response.data.count || 0;
    } catch (error) {
      console.error('Error fetching users count:', error);
      throw error;
    }
  },

  // Get crypto data with health info
  getCryptoData: async (params = {}) => {
    try {
      const response = await apiClient.get('/crypto-data/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching crypto data:', error);
      throw error;
    }
  },

  // Get US stock data with health info
  getUSStockData: async (params = {}) => {
    try {
      const response = await apiClient.get('/us-data/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching US stock data:', error);
      throw error;
    }
  },

  // Get India stock data with health info
  getIndiaStockData: async (params = {}) => {
    try {
      const response = await apiClient.get('/india-data/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching India stock data:', error);
      throw error;
    }
  },

  // Get polling logs for health monitoring
  getPollingLogs: async (params = {}) => {
    try {
      const response = await apiClient.get('/polling-logs/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching polling logs:', error);
      throw error;
    }
  },
};

// Export API client for custom requests
export { apiClient };
export default dashboardApi;